@if (!alert.closed) {
  <ngb-alert type="light"  [dismissible]="!isPreview" (close)="closeAlert()">
    <div (click)="showAlert()">
      <h4 class="text-danger">{{alert.language_definitions[0].title}}</h4> <span>{{alert.language_definitions[0].content}}</span>
    </div>
  </ngb-alert>
}
